/**
 * MUI X Date Pickers theme slots: `MuiPickersPopper`, `MuiPickersMonth`, `MuiPickersYear` — popper border, typography.
 * Discoverability: `MuiPickersPopper`, `DatePicker`, `PickersPopper`, `@mui/x-date-pickers-pro`.
 *
 * @see https://mui.com/x/react-date-pickers/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiPickers(
  theme: Theme,
): Pick<Components<Theme>, 'MuiPickersPopper' | 'MuiPickersMonth' | 'MuiPickersYear'> {
  const { palette } = theme;
  return {
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          border: `1px solid ${palette.border.light}`,
        },
      },
    },

    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          ...theme.typography.bodyRegular,
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          ...theme.typography.bodyRegular,
        },
      },
    },
  };
}
